import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    appTitle: 'xView',
    // baseUrl: 'http://localhost:3000',  // local dev/debug
    // submitUrl: 'http://localhost:3001', //
    baseUrl: 'https://api-main.xviewdataset.org:443', // https
    submitUrl: 'https://api-sub.xviewdataset.org:443', // https
    errorMessage: ''
  },

  mutations: {
    setErrorMessage (state, errorMessage) {
      state.errorMessage = errorMessage
    }
  },

  actions: {},

  getters: {
    appTitle (state) {
      return state.appTitle
    },
    baseUrl (state) {
      return state.baseUrl
    },
    submitUrl (state) {
      return state.submitUrl
    },
    errorMessage (state) {
      return state.errorMessage
    }
  }

})



// WEBPACK FOOTER //
// ./src/store/index.js